import { render } from "./keywords-for-online-ws-parser-action.vue?vue&type=template&id=b4ba6870"
import script from "./keywords-for-online-ws-parser-action.vue?vue&type=script&lang=js"
export * from "./keywords-for-online-ws-parser-action.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__